import {Maps} from "../../reckon-api";
import {useEffect, useRef, useState} from "react";
import {ValorantApi} from "../../valorant-api/api";
import {CircularProgress, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {MapData, MapResponse} from "../../valorant-api/types";


export default function DecoratedMap(props: {map: Maps}){
    const [mapData, setMapData] = useState(undefined as MapData|undefined);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [containerSize, setContainerSize] = useState<number>(512);

    useEffect(() => {
        if (!props.map.uuid) {
            return;
        }
        ValorantApi.getMap(props.map.uuid)
          .then((response) => {
            setMapData(response.data as MapData);
          })
    }, [props.map]);

    const map_url = `https://res.cloudinary.com/xenesis/image/upload/valAssets/${props.map?.id}.png`;

    const decoration_adjustments: Record<string, {x: number, y:number}> = {
        'sunset': {x: 0.07, y:-0.08}
    }

    useEffect(() => {
        if (wrapperRef.current) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    if (entry.contentRect) {
                        const size = Math.floor(Math.min(entry.contentRect.width, entry.contentRect.height));
                        setContainerSize(size);
                    }
                }
            });

            resizeObserver.observe(wrapperRef.current);

            return () => {
                resizeObserver.disconnect();
            };
        }
    }, []);

    // Fallback to cloudinary image if no valorant-api uuid available
    if (!props.map.uuid) {
        return (
            <Box
                ref={wrapperRef}
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        width: containerSize,
                        height: containerSize,
                        backgroundImage: `url(${map_url})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}
                />
            </Box>
        );
    }

    return mapData ?
        <Box
            ref={wrapperRef}
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: containerSize,
                    height: containerSize,
                    backgroundImage: `url(${mapData?.displayIcon})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                {
                    mapData.callouts.map(c => {
                        return <Typography key={c.regionName} sx={{
                            position: 'absolute',
                            top: `${(100 * (((c.location.x * mapData.yMultiplier) + (mapData.yScalarToAdd + (decoration_adjustments[props.map.id] ? decoration_adjustments[props.map.id].y : 0))))).toFixed(1)}%`,
                            left: `${(100 * (((c.location.y * mapData.xMultiplier) + (mapData.xScalarToAdd+ (decoration_adjustments[props.map.id] ? decoration_adjustments[props.map.id].x : 0))))).toFixed(1)}%`,
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                        }}>
                            {`${c.superRegionName.split(' ')[0]}`}-
                            {`${c.regionName}`}<br/>
                        </Typography>
                    })
                }
            </Box>
        </Box> :
        <CircularProgress sx={{width:'100%', height:'100%'}}/>
}